<template>
<b-row class="wlp-header no-gutters">
  <b-col v-if="pageTitle == pageIntendedUse|| pageTitle == pageMoreInfo || pageTitle== pageRef || pageTitle== pageTerms || pageTitle == pageEmail" cols="12">
    <div class="page-title-single">{{pageTitle}}</div>
  </b-col>

  <b-col v-if="pageTitle != pageIntendedUse && pageTitle != pageMoreInfo && pageTitle!= pageRef &&  pageTitle!= pageTerms &&  pageTitle!= pageEmail" cols="12">
    <b-row class=" header-sec no-gutters">
      <b-col class="left-column" cols="7">

        <div v-if="pageTitle == pageMenu || pageTitle == pageSummary" class="page-title font-menu">{{pageTitle}}</div>
        <b-row class=" no-gutters" v-if="pageTitle != pageMenu && pageTitle != pageSummary && pageTitle != pageEmail">
          <b-col class="icon-col" cols="2" >
            <div class="title-img" :class="pageImage"></div>
          </b-col>

          <b-col class="heading-col safari_only" cols="10">
            <div class="font-cancer" :class="{'pcos-xs': pageTitle==pageinfertility, 
            'font-spacing' : pageTitle==pageNAFLD|| pageTitle == pageLifeLost, 
            'hypertension-heading': pageTitle== pageHypertension|| pageTitle==pageDiabetes, 
            'type2-heading':  pageTitle==pageDiabetes,
             'yol-head':pageTitle ==  pageLifeLost,
            'hyperlipidemia-head':pageTitle==pageDyslipidemia ,
            'pcos-heading': pageTitle==pageinfertility , 
            'ed-heading': pageTitle==pageOsteoarthritis ,
            'long-title':pageTitle=='Años de vida perdidos'}">{{pageTitle}}
           
            </div>
          </b-col>
        </b-row>
      </b-col>

      <b-col class="right-column" cols="5">
        <b-row class="hdr-vertical no-gutters">
          <b-row class="data-sec no-gutters">
            <b-col cols="12" class="inner-width-m">
              <b-row class=" no-gutters">
                <b-col lg = "3" md="6" sm="4" cols="6" v-if="!validWeight()">
                  <b>{{ $t('common.weight') }}:</b><span class="data-spacing"></span>-
                </b-col>
                <b-col lg = "3" md="6" sm="4" cols="6" v-if="validWeight()">
                  <b>{{ $t('common.weight') }}:</b><span class="data-spacing"></span>{{userData.weight}}
                </b-col>
                <b-col  lg = "5" md="6" sm="5"  cols="6">
                  <div class="height-space" :class="{'height-space-sp' : $i18n.locale=='sp'}">
                    <b>{{ $t('common.height') }}:</b><span class="data-spacing"></span>
                    <span v-if="!validHeight()">-</span>
                    <span v-if="validHeight()">{{userData.height}} <span v-if="userData.unitsSystem==='englishSystem'">{{ $t('common.inches') }}</span>
                    <span v-if="userData.unitsSystem==='metricSystem'">cm</span>
                    </span>
                  </div>
                </b-col>
                <b-col  lg = "4" md="6" sm="3" cols="6">
                  <b>BP:</b><span class="data-spacing2"></span>
                  <span v-if="this.userData.systolicBp>=90 && this.userData.systolicBp<300 && this.userData.diastolicBp>=50 && this.userData.diastolicBp<200">
                    {{userData.systolicBp}}/{{userData.diastolicBp}}</span>
                </b-col>
              <!--</b-row>-->
              <!--<b-row class=" no-gutters">-->
                <b-col  lg = "3" md="6" sm="4"  cols="6">
                  <b>{{ $t('common.age') }}:</b><span class="data-spacing"></span>
                  <span v-if="!(this.userData.age>=20 && this.userData.age<=79)">-</span>
                  <span v-if="(this.userData.age>=20 && this.userData.age<=79)">{{userData.age}}</span>
                </b-col>
                <b-col  lg = "5" md="6" sm="5" xs="6" cols="6">
                  <div class="height-space" :class="{'height-space-sp' : $i18n.locale=='sp'}">
                    <b>{{ $t('common.gender') }}:</b><span class="data-spacing"></span>
                    <span v-if="this.userData.gender==''">-</span>
                    <span v-if="this.userData.gender!='' && $i18n.locale=='sp' && userData.gender == 'Male'">{{$t('common.male')}}</span>
                    <span v-if="this.userData.gender!='' && $i18n.locale=='sp' && userData.gender == 'Female'">{{$t('common.female')}}</span>
                    <span v-if="this.userData.gender!='' && $i18n.locale=='en'">{{userData.gender}}</span>
                  </div>
                </b-col>
                <b-col  lg = "4" md="6" sm="3" cols="6">
                  <b>{{ $t('common.bmi') }}:</b><span class="data-spacing"></span>
                  <span v-if="!(userData.bmi>0 && userData.bmi<100)">-</span>
                  <span v-if="(userData.bmi>0 && userData.bmi<100)">{{userData.bmi}}</span>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-row>
      </b-col>
    </b-row>
  </b-col>
</b-row>
</template>
<script>
  import { mapGetters } from 'vuex';
  export default {
    name: "wlpHeader",
    mounted: function() {
      
    },
    components: {},
    computed: {
      ...mapGetters('userData', ['userData']),
  },

    data() {
      return {
        pageTerms: this.$t('terms.pageTitle'),
        pageIntendedUse: this.$t('IntendedUse.pageTitle'),
        pageEmail: this.$t('email.pageTitle'),
        pageMenu: this.$t('Menu.pageTitle'),
        pageHypertension: this.$t('common.hypertension'),
        pageCancer: this.$t('common.cancer'),
       pageNAFLD:this.$t('common.NAFLD'),
    pageinfertility:this.$t('infertility.pageTitle2') ,
    pageOsteoarthritis: this.$t('common.osteoarthritis'),
    pageDyslipidemia: this.$t('common.dyslipidemia'),
    pageLifeLost:   this.$t('lifelost.pageTitle'), 
    pageDiabetes: this.$t('common.diabetes'),
    pageSummary: this.$t('summary.pageTitle'),
     pageMoreInfo: this.$t('ref.pageTitle'),
    pageRef: this.$t('info.pageTitle')
      };
    },
    props: {
      pageTitle: {
        type: String,
        required: true
      },
      pageImage: {
        type: String,
        required: false
      },
      subtext: {
        type: String,
        required: false
      }
    },
    
    methods: {
      validWeight: function() {
        if (this.userData.unitsSystem === 'englishSystem') {
          return (this.userData.weight>=70 && this.userData.weight<=600);
        } else {
          return (this.userData.weight>=32 && this.userData.weight<=272);
        }
      },
      
      validHeight: function() {
        if (this.userData.unitsSystem === 'englishSystem') {
          return (this.userData.height>=48 && this.userData.height<=88);
        } else {
          return (this.userData.height>=122 && this.userData.height<=224);
        }
      },
      
    }
  };
</script>

<style lang="scss" scoped>
</style>
